<template>
  <div class="wrapper">
    <right-header @toggleMenu="open = !open" :show-reload="['stats', 'feeds'].includes($route.name)" />
    <div class="content-wrapper">
      <LeftSide :open="open" />
      <div class="right-side">
        <main class="main">
          <ContentHeader />
          <div class="page-content">
            <router-view />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader';
import LeftSide from '@/components/LeftSide';
import RightHeader from '@/components/MainHeader';
import { useStorage } from '@vueuse/core';

const sidebarOpen = useStorage('sidebar.open', false);

export default {
  name: 'Sidebar',
  components: {
    ContentHeader,
    LeftSide,
    RightHeader,
  },
  data() {
    return {
      open: sidebarOpen,
    };
  },
};
</script>
